<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Log a Call</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit">
                <b-row>
                    <!-- FIELD LEADS -->
                    <b-col cols="12" md="12">
                        <b-form-group label="Lead Name:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallLead'"
                            >
                            <el-select v-model="new_call.leads_id" filterable placeholder="Select" :disabled="isLeadDataExists">
                                <el-option
                                v-for="lead in leadName"
                                :key="lead.lead_id"
                                :label="lead.name"
                                :value="lead.lead_id"
                                >
                                </el-option>
                            </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD CALL TITLE -->
                    <b-col cols="12">
                        <b-form-group label="Subject:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallTitle'"
                            >
                                <b-form-input
                                v-model="new_call.subject"
                                required
                                placeholder="Subject"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD CALL REMARK CALL -->
                    <b-col cols="12">
                        <b-form-group label="Remark Call:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallRemark'"
                            >
                                <b-form-textarea
                                id="textarea"
                                v-model="new_call.remark_call"
                                placeholder="Remark Call"
                                rows="3"
                                max-rows="6"
                                required
                                ></b-form-textarea>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD CALL TYPE -->
                    <b-col cols="12">
                        <b-form-group label="Call Type:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallTitle'"
                            >
                            <el-select v-model="new_call.call_type" filterable placeholder="Select">
                                <el-option
                                v-for="(type, index) in callType"
                                :key="index"
                                :label="type.label"
                                :value="type.value">
                                </el-option>
                            </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD CALL DATE -->
                    <b-col cols="12" md="12">
                        <b-form-group label="Date Call:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallType'"
                            >
                            <el-date-picker
                            v-model="new_call.date_call"
                            type="date"
                            placeholder="Pick a day"
                            value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD TIME START -->
                    <b-col cols="12" md="6">
                        <b-form-group label="Time Start:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallStartTime'"
                            >
                            <el-time-picker
                                v-model="new_call.time_start"
                                placeholder="Time Start"
                                format="HH:mm A"
                                value-format="HH:mm:ss"
                                >
                            </el-time-picker>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD TIME END -->
                    <b-col cols="12" md="6">
                        <b-form-group label="Time End:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'newCallEndTime'"
                            >
                            <el-time-picker
                                v-model="new_call.time_end"
                                placeholder="Time Start"
                                format="HH:mm A"
                                value-format="HH:mm:ss"
                                >
                            </el-time-picker>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Log Call</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, TimePicker, DatePicker, Form } from 'element-ui'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
} from '@/assets/js/httpImports.js'
import { EventBus } from "@/main";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

export default {
    props:{
        log_call: Boolean,
        leadData: Object,
    },
    mixins:[helperFunctionMixin,notifyFunctionMixin],
    components: {
        ValidationObserver,
        ValidationProvider,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [TimePicker.name]: TimePicker,
        [DatePicker.name]: DatePicker,
        [Form.name]: Form,
    },
    created(){
        if (!this.leadData) {
            this.fetchLead()
            if(this.checkAppCode('sas')){
                // this.fetchHub()
            }
        }
    },
    computed: {
        show: {
            get() {
                return this.log_call;
            },
            set(newVal) {
                this.$emit('update:log_call', newVal);
            },
        },
        isLeadDataExists() {
            return !!this.leadData;
        }
    },
    watch: {
        leadData: {
            immediate: true,
            handler(newLeadData) {
            if (newLeadData) {
                this.new_call.leads_id = Number(newLeadData.lead_id);
                // this.new_call.leads_id = newLeadData.name;
            }
            }
        }
    },
    data(){
        return {
            new_call:{
                leads_id: "",
                subject: "",
                remark_call:"",
                call_type: "",
                date_call: "",
                time_start: "",
                time_end: "",
                minutes_call: "",
                assigned_to: "",
            },
            leadName: [],
            hubName: [],
            callType: [{
                value: 'Outbound',
                label: 'Outbound'
                }, {
                value: 'Inbound',
                label: 'Inbound'
            }],
        }
    },
    methods: {
        fetchLead(){
            axios.get(services.lead + 'leads', {headers: getHeader()})
            .then(res => {
                this.leadName = res.data.data.data
                this.$emit('listLead',res.data.data)
            })
            .catch(e => {
                this.isTableLoading = false
                this.errorFunction(e)
            })
        },
        fetchHub(){
            axios.get(services.hub + 'hubs', {headers: getHeader()})
            .then(res => {
                this.hubName = res.data.data
            })
            .catch(e => {
                this.isTableLoading = false
                // this.errorFunction(e)
            })
        },
        submit(){
            // console.log(this.leadData.hub.hub_id)
            let form = new FormData()
            form.append('lead_id',this.new_call.leads_id)
            form.append('subject',this.new_call.subject)
            form.append('call_type',this.new_call.call_type)
            form.append('date_call',this.new_call.date_call)
            form.append('time_start',this.new_call.time_start)
            form.append('time_end',this.new_call.time_end)
            this.leadData.assign_to.member ? form.append('hub_id',this.leadData.hub.hub_id) : form.append('hub_id',this.new_call.assigned_to)
            // form.append('hub_id',this.new_call.assigned_to)
            form.append('remark_call',this.new_call.remark_call)
            form.append('call_status','Completed')
            axios.post(services.lead + 'call', form, { headers: getHeader() })
                .then(res => {
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Created.')
                    this.$emit('closeLogCallModal', false);
                    EventBus.$emit('getnewcall',res)
                    this.new_call.leads_id = ""
                    this.new_call.subject = ""
                    this.new_call.call_type = ""
                    this.new_call.date_call = ""
                    this.new_call.time_start = ""
                    this.new_call.time_end = ""
                    this.new_call.minutes_call = ""
                    this.new_call.assigned_to = ""
                })
                .catch(e => {
                    console.log(e)
                    this.errorFunction(e)
                })
        }
    }
}
</script>